module.exports = __webpack_public_path__ + "img/link.770cae0b.svg";